import { ReactNode } from 'react';
import { StackedCardWizardProvider, WizardCallbacks } from './stacked-card-wizard-context';

type Props = {
  children: ReactNode;
  secondaryAction?: ReactNode;
} & WizardCallbacks;

export const StackedCardWizard = ({ children, secondaryAction, onStepChange, onComplete }: Props) => {
  return (
    <StackedCardWizardProvider secondaryAction={secondaryAction} onStepChange={onStepChange} onComplete={onComplete}>
      {children}
    </StackedCardWizardProvider>
  );
};
